const Login = () => (
    window.location.href = "https://login.wappa.com.br/"
);

export default Login;